export default __webpack_public_path__ + "static/media/Blueprint.632c9874.jpg";